
import { mapGetters } from 'vuex';
import bgColor from '../../../../mixins/bg-color';

const { Glide: VueGlide, GlideSlide: VueGlideSlide } = require('vue-glide-js');

export default {
    name: 'CardListCards',
    components: {
        VueGlide,
        VueGlideSlide,
    },
    mixins: [ bgColor ],
    props: {
        contentType: {
            type: String,
            required: false,
            default: 'cardList',
        },
        internal: {
            type: String,
            required: false,
            default: '',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        countOverride: {
            type: [Number, String],
            required: false,
            default: '',
        },
        display: {
            type: Object,
            required: false,
            default: () => ({
                component: 'cards',
                background: 'none',
            }),
        },
        cards: {
            type: Array,
            required: false,
            default: () => [],
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        cardBackground: {
            type: String,
            required: false,
            default: 'transparent',
        },
        foodMenu: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        active: 0,
    }),
    computed: {
        ...mapGetters({
            bps: 'breakpoints/getState',
            bpsLimits: 'breakpoints/getLimits',
        }),
        vueGlideSettings() {
            if (this.cardCount === 'many') {
                return {
                    breakpoints: {
                        [this.bpsLimits.smallDesktop]: {
                            perView: 2,
                        },
                        [this.bpsLimits.largeMobile]: {
                            perView: 1,
                        },
                    },
                    perView: 3,
                    gap: 24,
                };
            }

            return {};
        },
        cardCount() {
            if (this.countOverride) {
                return this.countOverride;
            } else if (this.cards.length < 3) {
                return 2;
            } else if (this.cards.length < 5) {
                return this.cards.length;
            }

            return 'many';
        },
        isRightDisabled() {
            let offset;

            if (this.bps.atMostMobile) {
                offset = 1;
            } else if (this.bps.atMostLargeMobile) {
                offset = 2;
            } else {
                offset = 3;
            }

            return this.active >= (this.cards.length - offset);
        },
        cardClasses() {
            return {
                card: true,
                [`card--${this.cardBackground}`]: true,
            };
        },
        icons() {
            const [protocol, domain] = this.$store.getters['layout/getHost'].split('//');
            const [subdomain, site] = domain.split('.');
            const usesAllergenIcons = [
                'ploq',
                'helmisimpukka',
            ];
            if (usesAllergenIcons.includes(site) || usesAllergenIcons.includes(subdomain)){
                return true;
            }

            return false;
        },
    },
    methods: {
        resolveActive(direction) {
            let offset = 3;

            if (this.bps.isLargeMobile) {
                offset = 2;
            } else {
                offset = 1;
            }

            switch (direction) {
                case 'left':
                    if (this.active - offset < 0) {
                        this.active = 0;
                    } else {
                        this.active = this.active - offset;
                    }
                    break;

                case 'right':
                    if (this.active + offset > this.cards.length) {
                        this.active = this.cards.length;
                    } else {
                        this.active = this.active + offset;
                    }
                    break;
            }
        },
        getCardExtras(card) {
            const extras = [];

            if (card.byline) {
                extras.push(card.byline);
            }

            return extras;
        },
        getSpecialty(spec) {
            switch (spec) {
                case 'G':
                    return 'allergens-gluten-free-filled';
                    break;
                case 'L':
                    return 'allergens-lactose-free-filled';
                    break;
                case 'C':
                    return 'allergens-contains-milk-filled';
                    break;
                case 'VL':
                    return 'allergens-low-lactose-filled';
                    break;
                case 'M':
                    return 'allergens-diary-free-filled';
                    break;
                case 'V':
                    return 'vegan';
                    break;
            }

            return 'error';
        },
        isProductTag(tag) {
            return [
                'productVegansk',
                'productVeg',
            ].includes(tag);
        },
        allergenPresent(allergen) {
            const products = this.cards.map(card => card.byline.specialties && card.byline.specialties.includes(allergen));

            return products.includes(true);
        },
    },
    i18n: {
        messages: {
            'fi-FI': {
                default: {
                    button: {
                        left: 'Nuoli vasen',
                        right: 'Nuoli oikea',
                    },
                    productVegansk: 'Vegansk',
                    productVeg: 'VEG',
                    allergens: {
                        glutenfree: 'Gluteenittomista raaka-aineista (lisätietoja henkilökunnalta)',
                        lactosefree: 'Laktoositon',
                        lowlactose: 'Vähälaktoosinen',
                        milk: 'Maidoton',
                        vegan: 'Vegaaninen',
                    },
                },
            },
            'en-EU': {
                default: {
                    button: {
                        left: 'Arrow left',
                        right: 'Arrow right',
                    },
                    productVegansk: 'Vegan',
                    productVeg: 'VEG',
                    allergens: {
                        glutenfree: 'Glutenfree',
                        lactosefree: 'Lactosefree',
                        lowlactose: 'Low Lactose',
                        lowlactose: 'Low Lactose',
                        milk: 'Milk',
                        vegan: 'Vegan',
                    },
                },
            },
            'sv-SE': {
                default: {
                    button: {
                        left: 'Arrow left',
                        right: 'Arrow right',
                    },
                    productVegansk: 'Vegansk',
                    productVeg: 'VEG',
                    allergens: {
                        glutenfree: 'Glutenfri',
                        lactosefree: 'Laktosfri',
                        lowlactose: 'Low Lactose',
                        milk: 'Mjölkfri',
                        vegan: 'Vegansk',
                    },
                },
            },
        },
    },
};
